<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">分享链接</h3>
      <div v-if="data">
        <div style="color: rgb(150,150,150)">温馨提示：请输入少于500个字符！！</div>
        <Input type="textarea" :rows="4" :maxlength="500" v-model="data.projectShareUrl"/>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {getProjectConfigInfo,saveProjectConfigInfo} from "../../../../api/projectConfig";

  export default {
    name: "ShareModal",
    props:{
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        this.data=null
        this.getProjectConfigInfo()
        this.isShow=true
      },
    },
    data(){
      return {
        isShow:false,
        data:null,
        loading:true,
      }
    },
    methods:{
      getProjectConfigInfo(){
        if(!this.fid){
          return
        }
        var params={
          fid:this.fid
        }
        getProjectConfigInfo(params).then(res=>{
          this.data=res.data
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){
        saveProjectConfigInfo(this.data).then(res=>{
          this.$Message.success('分享链接保存成功')
          this.isShow=false
        })
      },

    },

  }
</script>

<style scoped>

</style>
